<script lang="ts" setup>
import type { StrapiPageError } from '@autobid/strapi-integration/typescript/strapi/Page'
import { useDetailsCar } from '@autobid/ui/composables/car/data/useDetailsCar'
import { useAuctionValidator } from '@autobid/ui/composables/useAuctionValidator'
import { getIdFromSlug } from '@autobid/ui/utils/car/getIdFromSlug'
import { computed, onServerPrefetch } from 'vue'

function handleError(error: StrapiPageError) {
  return showError({
    statusCode: error.code,
    statusMessage: error.message,
  })
}

const route = useRoute()
const slug = route.params.slug.toString()
const carId = computed(() => getIdFromSlug(slug))

function validateCarId() {
  if (!carId.value) {
    showError({
      statusCode: 404,
    })
  }
}
validateCarId()

const { data: car, suspense } = useDetailsCar(carId, {
  keepPreviousData: true,
})

onServerPrefetch(suspense)
await suspense()
await useAuctionValidator(car.value?.item.itemData.auctionId)

function validateSlug() {
  if (
    !car.value
    || car.value.item.itemData.slug !== slug
    || car.value.item.itemData.stage === 'REMOVED'
  ) {
    showError({ statusCode: 404 })
  }
}
validateSlug()
</script>

<template>
  <autobid-page
    key="details"
    slug="details"
    ignore-blacklist
    @error="handleError"
  >
    <template #default="{ pageData }">
      <Suspense v-if="pageData?.page">
        <template #default>
          <sections-auction-car-middleware v-if="car" :car="car.item.itemData">
            <CommonStrapiPage :page-data="pageData" />
          </sections-auction-car-middleware>
        </template>

        <template #fallback>
          <div class="container mx-auto">
            <AutobidRenderComponents
              :components="pageData.components ?? []"
              fallback
            />
          </div>
        </template>
      </Suspense>
    </template>
  </autobid-page>
</template>
